import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\Enaos\EnaosGetInfoDossierForOrderController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Enaos/EnaosGetInfoDossierForOrderController.php
* @route '/api/funeral-home/{funeral_home}/enaos/sales-export/info'
*/
const EnaosGetInfoDossierForOrderController = (args: { funeral_home: string | number | { id: string | number } } | [funeral_home: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: EnaosGetInfoDossierForOrderController.url(args, options),
    method: 'get',
})

EnaosGetInfoDossierForOrderController.definition = {
    methods: ["get","head"],
    url: '/api/funeral-home/{funeral_home}/enaos/sales-export/info',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\Enaos\EnaosGetInfoDossierForOrderController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Enaos/EnaosGetInfoDossierForOrderController.php
* @route '/api/funeral-home/{funeral_home}/enaos/sales-export/info'
*/
EnaosGetInfoDossierForOrderController.url = (args: { funeral_home: string | number | { id: string | number } } | [funeral_home: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { funeral_home: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { funeral_home: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            funeral_home: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        funeral_home: typeof args.funeral_home === 'object'
        ? args.funeral_home.id
        : args.funeral_home,
    }

    return EnaosGetInfoDossierForOrderController.definition.url
            .replace('{funeral_home}', parsedArgs.funeral_home.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\Enaos\EnaosGetInfoDossierForOrderController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Enaos/EnaosGetInfoDossierForOrderController.php
* @route '/api/funeral-home/{funeral_home}/enaos/sales-export/info'
*/
EnaosGetInfoDossierForOrderController.get = (args: { funeral_home: string | number | { id: string | number } } | [funeral_home: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: EnaosGetInfoDossierForOrderController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FuneralHomePartner\Enaos\EnaosGetInfoDossierForOrderController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Enaos/EnaosGetInfoDossierForOrderController.php
* @route '/api/funeral-home/{funeral_home}/enaos/sales-export/info'
*/
EnaosGetInfoDossierForOrderController.head = (args: { funeral_home: string | number | { id: string | number } } | [funeral_home: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: EnaosGetInfoDossierForOrderController.url(args, options),
    method: 'head',
})

export default EnaosGetInfoDossierForOrderController